import { tabsLi } from "./utils/options";
import { useNavigate } from "react-router-dom";
import {
  BuildingLibraryIcon,
  Header,
  IdentificationIcon,
  InformationCircleIcon,
  Link,
  Outlet,
  SwatchIcon,
  useEffect,
  useLocation,
  UserGroupIcon,
} from "@";

const ICON_MAP = {
  InformationCircleIcon,
  UserGroupIcon,
  BuildingLibraryIcon,
  IdentificationIcon,
  SwatchIcon,
};

const Index = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const links = [{ name: "عن الجمعية", link: "" }];

  const activeConfig = (link) => location.pathname.endsWith(`/${link}`);

  useEffect(() => {
    location.pathname === "/association-manager" &&
      navigate("/association-manager/info");
  }, [location, navigate]);

  return (
    <>
      <Header title="عن الجمعية" links={links} />

      <main>
        {/* Refined segmented tab navigation */}
        <nav className="relative">
          <div className="relative -mx-1 flex items-center gap-1 overflow-x-auto whitespace-nowrap rounded-2xl border border-gray-100 bg-gradient-to-l from-purple-50/30 via-white to-purple-50/20 p-1.5 backdrop-blur-sm [-ms-overflow-style:none] [scrollbar-width:none] dark:border-gray-700/60 dark:from-purple-950/20 dark:via-gray-800 dark:to-purple-950/10 [&::-webkit-scrollbar]:hidden">
            {tabsLi.map(({ link, name, icon }) => {
              const Icon = ICON_MAP[icon];
              const isActive = activeConfig(link);
              return (
                <Link
                  to={link}
                  key={link}
                  className={`group/tab relative inline-flex shrink-0 items-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-medium tracking-tight transition-all duration-200 ${
                    isActive
                      ? "bg-gradient-to-br from-purple-800 to-purple-950 text-white shadow-md shadow-purple-900/25 ring-1 ring-purple-900/10 dark:from-purple-600 dark:to-purple-800"
                      : "text-gray-600 hover:bg-white hover:text-purple-900 hover:shadow-sm dark:text-gray-400 dark:hover:bg-gray-700/60 dark:hover:text-purple-300"
                  }`}
                >
                  {Icon && (
                    <Icon
                      className={`h-4 w-4 transition-transform ${
                        isActive ? "" : "group-hover/tab:scale-110"
                      }`}
                    />
                  )}
                  <span>{name}</span>
                </Link>
              );
            })}
          </div>
        </nav>

        <div className="py-5 lg:py-8 print:p-0">
          {location.pathname !== "/association-manager" ? (
            <Outlet />
          ) : (
            <div className="card flex w-full items-center justify-center p-5 text-lg font-bold dark:text-gray-400">
              حدد العنصر من القائمة
            </div>
          )}
        </div>
      </main>
    </>
  );
};

export default Index;
